import './ThankYouLenderList.css';
import React, { useEffect, useRef } from 'react';
import { Testimonials } from '../MainPage';
import { useLocation } from 'react-router-dom';
import parse, { domToReact } from "html-react-parser";
import { useAppContext, useLendersContext } from '../../lib/contexts';
import { CustomLink } from '../CustomComponents';
import { useScrollToTop } from '../../lib/hooks';

function ThankYouLenderList() {
  const { name, lenders = [], pixelContext } = useLendersContext();
  const { state } = useLocation();
  const { pixel } = state || {};

  const { appContext, isAppContextReady } = useAppContext();

  const voidElements = new Set([
    'area',
    'base',
    'br',
    'col',
    'command',
    'embed',
    'hr',
    'img',
    'input',
    'keygen',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr',
  ]);

  const lenderContainerRef = useRef(null);

  const stopPropagation = (event) => {
    event.stopImmediatePropagation();
  };

  useEffect(() => {
    if (!isAppContextReady) return;

    const {
      publisher_id,
      subid,
      cake,
    } = appContext;

    const params = new URLSearchParams(window.location.search);

    if (publisher_id) params.set('publisher_id', publisher_id);
    if (subid) params.set('subid', subid);
    if (cake) params.set('cake', cake);

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState(null, '', newUrl);
  }, [appContext, isAppContextReady]);

  useEffect(() => {
    const container = lenderContainerRef.current;
    if (!container) return;

    const linkElements = container.querySelectorAll(
      '.thank-you-lenders__description .thank-you-lenders__description-bulletpoints ul li a'
    );

    linkElements.forEach((elem) =>
      elem.addEventListener('click', stopPropagation, true)
    );

    return () => {
      linkElements.forEach((elem) =>
        elem.removeEventListener('click', stopPropagation, true)
      );
    };
  }, []);

  const parseOptions = {
    replace: ({ attribs, children, name }) => {
      if (!attribs) return;

      const newAttribs = { ...attribs };
      delete newAttribs.style;
      delete newAttribs.className;

      if (attribs.href) {
        return (
          <CustomLink {...newAttribs}>
            {domToReact(children, parseOptions)}
          </CustomLink>
        );
      }

      if (voidElements.has(name)) {
        return React.createElement(name, newAttribs);
      }

      return React.createElement(
        name,
        newAttribs,
        domToReact(children, parseOptions)
      );
    },
  };

  useScrollToTop();

  return (
    <>
      {pixel && <div>{parse(pixel)}</div>}

      <section id="thankYouFirstSection">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <span>
                Thank you for your request {name}!<br />
                Our provider below will call you shortly.
              </span>
            </div>
          </div>
        </div>
      </section>

      <section id="lender-list" className="testiArea py-5">
        <div className="container">
          <div className="row">
            <div className="thank-you-lenders__list">
              {lenders.map(
                ({ logo, name, bulletpoints, link, phone, hidename }, index) => {
                  const parsedBulletPoints = parse(bulletpoints, parseOptions);

                  return (
                    <div
                      className="thank-you-lenders__card-wrapper"
                      key={`${name}-${index}`}
                    >
                      <div
                        className="thank-you-lenders__card"
                        ref={lenderContainerRef}
                        onClick={() => {
                          if (link) window.open(link, '_blank');
                        }}
                      >
                        <div className="thank-you-lenders__img">
                          <img src={logo} alt="matchedLogo" />
                        </div>

                        <div className="thank-you-lenders__description">
                          {(hidename === "no" || hidename === null) && (
                            <div className="thank-you-lenders__description-header">
                              <span>{name}</span>
                            </div>
                          )}

                          <div className="thank-you-lenders__description-bulletpoints">
                            {parsedBulletPoints}
                          </div>
                        </div>

                        {link && (
                          <div className="thank-you-lenders__quote-container">
                            <a
                              className="thankyou__lenders-quote-btn"
                              target="_blank"
                              href={link}
                              rel="noreferrer"
                            >
                              GET YOUR QUOTE!
                            </a>
                          </div>
                        )}
                      </div>

                      {phone && (
                        <h2
                          className="thank-you-lenders__phone"
                          onClick={() =>
                            window.open(`tel:${phone}`, '_blank')
                          }
                        >
                          {`Get the Help You Need - Call Now and Speak to an Expert ${phone}`}
                        </h2>
                      )}
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ThankYouLenderList;
